import React, { Dispatch, SetStateAction } from 'react'
import styled from '@emotion/styled'

type WithoutChildren<T = {}> =
    T & {
        checked: boolean
        setChecked: Dispatch<SetStateAction<boolean>>
        label?: string
        icon?: React.ReactNode
        displayCheckbox?: boolean
    }

const Content = styled.div`
    margin: 0.5rem;
    padding: 0.5rem;
    border: 0;
    border-radius: 2px 2px 2px 2px;
    outline: none;
    &:hover{
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
        transition: all 0.3s
    }
    background: none;
    display: flex;
    align-items: center;
`

const CustomCheckbox = styled.span`
    height: 16px;
    width: 16px;
    background-color: #eee;
    border-radius: 3px;
    display: inline-block;
    position: relative;

    input:checked + & {
        background-color: #4caf50;
    }

    input:checked + &:after {
        content: '';
        position: absolute;
        left: 5px;
        top: 1px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }
`

export function Checkbox({ checked, setChecked, label, icon, displayCheckbox = false }: WithoutChildren) {
    function check() {
        setChecked(!checked)
    }

    return <Content style={{ cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center' }} onClick={check}>
        {label && <div style={{ padding: '0 0.5rem' }}>{label}</div>}
        <input type='checkbox' checked={checked} onChange={check} style={{ display: 'none' }} />
        <CustomCheckbox />
        {icon}
    </Content>
}
